import { render, staticRenderFns } from "./CustomerMultiSelect.vue?vue&type=template&id=236af0e6"
import script from "./CustomerMultiSelect.vue?vue&type=script&lang=ts"
export * from "./CustomerMultiSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports